/**
 * Reusable Gemini-style logo: four-pointed star with concave curved sides
 * and vertical gradient (lavender → sky blue → blue). Used for Autofill
 * and AI-Powered Matching.
 */
import React from 'react';

const GeminiLogo = ({ className = 'h-5 w-5', size = 24, ariaHidden = true }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      className={className}
      aria-hidden={ariaHidden}
      fill="none"
    >
      <path
        d="M12 2 Q 12 12 22 12 Q 12 12 12 22 Q 12 12 2 12 Q 12 12 12 2 Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default GeminiLogo;
